import CustomAmplitudeClient from "../../js/custom-amplitude-client.0520d7b5cfdf.js";
import { ModalFilter } from "../../js/filters/modal_filter.1e670e215ac1.js";
import"../../js/filters/index.e115329c3fcd.js"; // Import file so we do not lose it in linting
import { PriceVerification } from "../../js/price-verification.a9be4fb8b871.js";
import { CareQuality } from "../../js/care-quality.eb8b7cbf9489.js";
import { MOBILE_SCREEN_QUERY } from "../../js/shared.525ab500164c.js";
import { OpenInsuranceSelectorEvent } from "../../js/insurance-selector-events.20ab5ea73f76.js";
import {
  MapMarkerSelectedEventType,
  HideMobileMapEventType,
  ShowMobileMapEventType,
} from "../../js/map-with-rates.cff7fffb9409.js";

class SearchPage {
  constructor() {
    this.config = JSON.parse(
      document.getElementById("page-config").textContent,
    );
    if (!this.config) throw new Error("unable to load page config");

    this.rates = JSON.parse(document.getElementById("rates-data").textContent);
    if (!this.rates) throw new Error("unable to load embedded rates");

    this.elements = this.queryDomElements();

    new ModalFilter();
    new PriceVerification();
    new CareQuality();
    this.amplitudeClient = new CustomAmplitudeClient(this.config.analyticsUrl);

    this.bindInputHandlers();
    this.bindMapToggle();
    if (this.elements.searchBarPopover) {
      this.amplitudeClient.setupSearchBarAnalytics(
        this.elements.searchBarPopover,
      );
    }
    this.bindFilterHandlers();
    this.bindEventListeners();
  }

  queryDomElements = () => {
    return {
      ratesForm: document.getElementById("rates-form"),
      openMobileSearchButton: document.getElementById("open-mobile-search"),
      closeMobileSearchButton: document.querySelectorAll(
        ".search-bar--popover .mobile-close",
      ),
      mapToggle: document.getElementById("map-toggle"),
      searchBarPopover: document.querySelector(".search-bar--popover"),
      checkCoverageLinks: document.querySelectorAll(".tqc-check-coverage"),
      modalForm: document.getElementById("all-filters-form"),
      exclusionsSwitch: document.getElementById("exclusions-switch"),
      resultsListContainer: document.getElementById("results-list-container"),
    };
  };

  bindEventListeners() {
    document.body.addEventListener("htmx:afterOnLoad", (e) => {
      // Re-query and bind elements that may have been replaced by htmx swap
      this.elements = this.queryDomElements();
      this.bindInputHandlers();
      new ModalFilter();
      new PriceVerification();
      new CareQuality();
    });
    document.addEventListener(MapMarkerSelectedEventType, (e) => {
      const card = document.getElementById(`search-card-${e.detail.cardIndex}`);
      card.scrollIntoView();
    });
  }

  bindMapToggle() {
    if (!this.elements.mapToggle) {
      return;
    }
    this.elements.mapToggle.addEventListener("click", (evt) => {
      evt.preventDefault();

      const showMobileMap = evt.target.innerText === "Map";
      if (showMobileMap) {
        this.elements.resultsListContainer.classList.add("pv-hide");

        this.elements.mapToggle.innerText = "List";

        document.dispatchEvent(
          new CustomEvent(ShowMobileMapEventType, { bubbles: true }),
        );
      } else {
        this.elements.resultsListContainer.classList.remove("pv-hide");

        this.elements.mapToggle.innerText = "Map";
        document.dispatchEvent(
          new CustomEvent(HideMobileMapEventType, { bubbles: true }),
        );
      }
    });
  }

  bindInputHandlers() {
    if (this.elements.exclusionsSwitch) {
      this.elements.exclusionsSwitch.addEventListener(
        "change",
        this.exclusionsSwitchChange,
      );
    }
    if (this.elements.openMobileSearchButton) {
      this.elements.openMobileSearchButton.addEventListener(
        "click",
        this.openMobileSearchOverlay,
      );
    }
    this.elements.closeMobileSearchButton.forEach((button) => {
      button.addEventListener("click", this.closeMobileSearchOverlay);
    });
    this.elements.checkCoverageLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (MOBILE_SCREEN_QUERY.matches) {
          this.openMobileSearchOverlay();
          document.dispatchEvent(new OpenInsuranceSelectorEvent());
        } else {
          document.dispatchEvent(new OpenInsuranceSelectorEvent(true));
        }
        // I have a hypothesis that users wont use this,
        // so tracking its usage.
        this.amplitudeClient.trackEvent("workflow_started", {
          workflow: "check_coverage",
        });
      });
    });
  }

  bindFilterHandlers() {
    document.addEventListener("tq:resetfilter", (e) => {
      this.elements = this.queryDomElements();
      const form = e.target.id.includes("all-filters")
        ? this.elements.modalForm
        : this.elements.ratesForm;
      for (const [formKey, filterValue] of Object.entries(e.detail)) {
        let element = form.elements[formKey];
        if (element instanceof RadioNodeList) {
          // RadioNodeLists are a collection of radio/checkboxes. Using RadioNodeList#value= works for setting a value,
          // but not for unchecking a radio button. This is needed to reset `care_quality` to be unselected
          for (let input of element) {
            input.checked = input.value === filterValue;
          }
        } else {
          if (filterValue == "null") {
            element.value = null;
          } else {
            element.value = filterValue;
          }
        }
      }
      form.elements["action"].value = "filter";
      form.submit();
    });
  }

  exclusionsSwitchChange = (evt) => {
    let func = "remove";
    if (evt.target.checked) {
      func = "add";
    }

    // save this cookie for 30 days
    document.cookie = `consumer_price_verification_enabled=${
      evt.target.checked
    }; max-age=${60 * 60 * 24 * 30}`;
    const verifiers = document.querySelectorAll(".tqc-package-result-card");
    verifiers.forEach((verifier) => verifier.classList[func]("tqc-verified"));
  };

  openMobileSearchOverlay = () => {
    this.elements.searchBarPopover.classList.remove("pv-hide-on-small");
    this.elements.searchBarPopover.classList.add("pv-inset-square-16");
  };

  closeMobileSearchOverlay = () => {
    this.elements.searchBarPopover.classList.add("pv-hide-on-small");
    this.elements.searchBarPopover.classList.remove("pv-inset-square-16");
  };
}

document.addEventListener("DOMContentLoaded", () => {
  new SearchPage();
});
